import { render, staticRenderFns } from "./_tabs.vue?vue&type=template&id=15297012&lang=pug&"
import script from "./_tabs.vue?vue&type=script&lang=js&"
export * from "./_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports